// src/features/media/components/MediaStatusBadge.tsx

import { Badge } from '@mantine/core';
import { MediaStatusType, MediaStateType } from '@lib2/model/media/MediaTypes';

interface MediaStatusBadgeProps {
  status: MediaStatusType;
  state: MediaStateType;
}

const STATUS_COLORS: Record<MediaStatusType, string> = {
  [MediaStatusType.Ready]: 'green',
  [MediaStatusType.Processing]: 'yellow',
  [MediaStatusType.Ingesting]: 'blue',
  [MediaStatusType.AwaitingIngest]: 'gray',
  [MediaStatusType.Error]: 'red',
  [MediaStatusType.Deleted]: 'gray',
};

const STATUS_LABELS: Record<MediaStatusType, string> = {
  [MediaStatusType.Ready]: 'Ready',
  [MediaStatusType.Processing]: 'Processing',
  [MediaStatusType.Ingesting]: 'Ingesting',
  [MediaStatusType.AwaitingIngest]: 'Waiting',
  [MediaStatusType.Error]: 'Error',
  [MediaStatusType.Deleted]: 'Deleted',
};

export function MediaStatusBadge({ status, state }: MediaStatusBadgeProps) {
  // For ready videos, show active/inactive state
  if (status === MediaStatusType.Ready) {
    const isActive = state === MediaStateType.Active;
    return (
      <Badge
        color={isActive ? 'green' : 'gray'}
        variant="light"
        size="sm"
      >
        {isActive ? 'Active' : 'Inactive'}
      </Badge>
    );
  }

  // For non-ready videos, show processing status
  return (
    <Badge
      color={STATUS_COLORS[status]}
      variant="light"
      size="sm"
    >
      {STATUS_LABELS[status]}
    </Badge>
  );
}
